module.exports = __webpack_public_path__ + "img/20200514_153336.dc0ae84e.jpg";